import { DeliveryWindowResource } from '../@api/Sylius';
import { DeliveryWindow } from './DeliveryWindow';

export const transformToDeliveryWindow = (resource: DeliveryWindowResource): DeliveryWindow => ({
    code: resource.code,
    description: resource.description || '',
    name: resource.name || '',
    position: resource.position || 0,
});
